var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "responsiveSection margin-vertical-60 margin-vertical-s-30",
    },
    [
      _c("div", { staticClass: "responsiveSection__grid" }, [
        _c("h2", { staticClass: "sectionRooftitle" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.trans("NEWS_ARCHIVE_ROOFTITLE")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "sectionHeadline" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.trans("NEWS_ARCHIVE_HEADLINE")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "width100 margin-top-10" }, [
          _c("div", { staticClass: "showMobile pos-relative" }, [
            _c("span", {
              staticClass: "fa fa-search pos-absolute pos-right-10 pos-top-10",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("label", [
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.trans("NEWS_ARCHIVE_SEARCH_PLACEHOLDER"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTerm,
                    expression: "searchTerm",
                  },
                ],
                staticClass: "formSearchbar__textfield--withIcon",
                attrs: {
                  type: "text",
                  value: "",
                  autocomplete: "off",
                  placeholder: _vm.trans("NEWS_ARCHIVE_SEARCH_PLACEHOLDER"),
                  maxlength: "1024",
                },
                domProps: { value: _vm.searchTerm },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchTerm = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm.locale === "de"
              ? _c("div", { staticClass: "flex flex--directionColumn" }, [
                  _c(
                    "label",
                    { staticClass: "margin-top-5 form_row__checkbox" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.checkedLocales,
                            expression: "checkedLocales",
                          },
                        ],
                        attrs: { type: "checkbox", name: "de", value: "de" },
                        domProps: {
                          checked: Array.isArray(_vm.checkedLocales)
                            ? _vm._i(_vm.checkedLocales, "de") > -1
                            : _vm.checkedLocales,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.checkedLocales,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = "de",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.checkedLocales = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.checkedLocales = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.checkedLocales = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.trans("NEWS_ARCHIVE_SEARCH_FILTER_1")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "form_row__checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.checkedLocales,
                          expression: "checkedLocales",
                        },
                      ],
                      attrs: { type: "checkbox", name: "en", value: "en" },
                      domProps: {
                        checked: Array.isArray(_vm.checkedLocales)
                          ? _vm._i(_vm.checkedLocales, "en") > -1
                          : _vm.checkedLocales,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.checkedLocales,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "en",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.checkedLocales = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.checkedLocales = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.checkedLocales = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.trans("NEWS_ARCHIVE_SEARCH_FILTER_2")) +
                        "\n                    "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "width66" },
            [
              _c("news", {
                attrs: {
                  items: _vm.newsFeeds,
                  search: _vm.searchTerm,
                  locales: _vm.checkedLocales,
                  "items-per-page": 15,
                  "init-page": _vm.page,
                },
                model: {
                  value: _vm.page,
                  callback: function ($$v) {
                    _vm.page = $$v
                  },
                  expression: "page",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "aside",
            { staticClass: "width33 aside padding-left-20 padding-left-s-0" },
            [
              _c("div", { staticClass: "hideMobile pos-relative" }, [
                _c("span", {
                  staticClass:
                    "fa fa-search pos-absolute pos-right-10 pos-top-10",
                }),
                _vm._v(" "),
                _c("label", [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      _vm._s(_vm.trans("NEWS_ARCHIVE_SEARCH_PLACEHOLDER"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchTerm,
                        expression: "searchTerm",
                      },
                    ],
                    staticClass: "formSearchbar__textfield--withIcon",
                    attrs: {
                      type: "text",
                      value: "",
                      autocomplete: "off",
                      placeholder: _vm.trans("NEWS_ARCHIVE_SEARCH_PLACEHOLDER"),
                      maxlength: "1024",
                    },
                    domProps: { value: _vm.searchTerm },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.searchTerm = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.locale === "de"
                  ? _c("div", { staticClass: "flex flex--directionColumn" }, [
                      _c(
                        "label",
                        { staticClass: "margin-top-5 form_row__checkbox" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkedLocales,
                                expression: "checkedLocales",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "de",
                              value: "de",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.checkedLocales)
                                ? _vm._i(_vm.checkedLocales, "de") > -1
                                : _vm.checkedLocales,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.checkedLocales,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "de",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.checkedLocales = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.checkedLocales = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.checkedLocales = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.trans("NEWS_ARCHIVE_SEARCH_FILTER_1")
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("label", { staticClass: "form_row__checkbox" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedLocales,
                              expression: "checkedLocales",
                            },
                          ],
                          attrs: { type: "checkbox", name: "en", value: "en" },
                          domProps: {
                            checked: Array.isArray(_vm.checkedLocales)
                              ? _vm._i(_vm.checkedLocales, "en") > -1
                              : _vm.checkedLocales,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.checkedLocales,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "en",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.checkedLocales = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checkedLocales = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checkedLocales = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.trans("NEWS_ARCHIVE_SEARCH_FILTER_2")) +
                            "\n                        "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.locale === ("de" || "en")
                ? _c("div", [
                    _c(
                      "div",
                      { staticClass: "hl-module margin-top-60 margin-top-s-0" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.trans(
                                "NEWS_ARCHIVE_RELEASE_CALENDAR_HEADLINE"
                              )
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm
                            .trans("NEWS_ARCHIVE_RELEASE_CALENDAR_TEXT")
                            .replace("{path}", _vm.paths.releases)
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "hl-module margin-top-60 margin-top-s-20" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.trans("NEWS_ARCHIVE_NEWSLETTER_HEADLINE")) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm
                        .trans("NEWS_ARCHIVE_NEWSLETTER_TEXT")
                        .replace(
                          "{press-path}",
                          `${_vm.paths.press}#pressnewsletterForm`
                        )
                        .replace("{info-path}", _vm.paths.infographics_all)
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "flex margin-top-10 width100" },
                  [
                    _vm._l(_vm.socialMediaLinks, function (socialMedia, index) {
                      return _c(
                        "li",
                        {
                          key: socialMedia.name,
                          staticClass: "flex__item",
                          class: { "margin-left-10": index > 0 },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "button",
                              class: `button--${socialMedia.name}`,
                              attrs: {
                                href: socialMedia.link,
                                "aria-label": `Social Media: ${socialMedia.name}`,
                                target: "_blank",
                                rel: "noopener",
                                "data-gtm": `social__${socialMedia.name.toLowerCase()}`,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: `fa-${socialMedia.name}`,
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.locale === "de"
                      ? _c("li", { staticClass: "flex__item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "button button--xing margin-left-10",
                              attrs: {
                                href: _vm.trans("SOCIAL_XING"),
                                "aria-label": "Social Media: XING",
                                target: "_blank",
                                rel: "noopener",
                                "data-gtm": "social__xing",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-xing",
                                attrs: { "aria-hidden": "true" },
                              }),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }